import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  cloudBucketFileName: string;
  fileName: string;
}

export const useDownloadTraceFileFromCloud = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ cloudBucketFileName, fileName }: HookProps) => {
      const result = await apiClient.batchesCore.downloadTraceFile.mutation({ body: { cloudBucketFileName, fileName } });
      if (result.status !== 200) throw result.body;

      const href = window.URL.createObjectURL(result.body as Blob);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully downloaded the old file!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading the old file!');
    },
  });
};
